import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import SocialSharing from "vue-social-sharing";
import JsonCSV from "vue-json-csv";
import "vue-context/src/sass/vue-context.scss";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(SocialSharing);
Vue.component("downloadCsv", JsonCSV);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");